module.exports = __webpack_public_path__ + "media/applicants/carroticon-4cb926b6.svg";